export default {
  claimList: {
    method: "get",
    url: "claim/v1/portal/claims",
  },
  claimDetail: {
    method: "get",
    url: "claim/v1/portal/claims/:claim_id",
  },
  claimDocuments: {
    method: "get",
    url: "claim/v1/portal/claims/:claim_id/documents",
  },
  downloadClaimReport: {
    method: "get",
    url: "claim/v1/portal/claims/download-report",
  },
};
